import React from 'react';
import { getTypographyClasses } from './Typography.utils';
import type { TypographyProps, TypographyRef } from './Typography.types';

export const Typography = React.forwardRef<TypographyRef, TypographyProps>(
  (
    {
      as: htmlTag = 'p', 
      variant,
      align,         
      className,
      children,
      ...props
    }: TypographyProps,
    ref
  ) => {
    const Component = htmlTag as React.ElementType;

    const componentClasses = getTypographyClasses(
      variant,
      align,       
      className     
    );

    return (
      <Component ref={ref} className={componentClasses} {...props}>
        {children}
      </Component>
    );
  }
);

Typography.displayName = 'Typography';

export default Typography;
